import { DefaultTheme } from 'styled-components'
import { IWholesalerConfig } from '~/wholesalers/IWholesalerConfig'

class Constants {
  public THEME: DefaultTheme
  public WHOLESALER: IWholesalerConfig = {} as IWholesalerConfig

  constructor() {
    this.WHOLESALER = WHOLESALERCONFIG
    this.THEME = WHOLESALERCONFIG.theme || {}
  }

  public get ANEX_API_ENDPOINT(): string {
    return (window as any).ANEX_API_ENDPOINT
  }

  public get NODE_ENV(): string {
    return (window as any).NODE_ENV
  }

  public get WHOLESALERSETTINGS(): IWholesalerConfig['settings'] {
    return this.WHOLESALER.settings || {}
  }

  public get WHOLESALERNAME(): string {
    return this.WHOLESALER.settings?.name || ''
  }

  public get WHOLESALERCODE(): string {
    return this.WHOLESALER.settings?.code || ''
  }

  public get LOGINURL(): string {
    if (this.WHOLESALERCODE.toLowerCase() === 'oe') {
      return this.NODE_ENV.toLowerCase() !== 'production'
        ? 'https://staticsite-router-staging.origindigital-pac.com.au/my/'
        : 'https://www.originenergy.com.au/my/'
    }
    return '/login'
  }
}

const constants = new Constants()

export { constants as Constants }

export const authKey = 'anex-oss-a'
